import DateRangeIcon from '@mui/icons-material/DateRange'
import { GridFilterModel } from '@mui/x-data-grid-premium'
import CustomFiltersModal from 'components/DataGrid/components/CustomFiltersModal'
import CustomDateRangeFilter from 'components/DataGrid/createColumns/CustomDateRangeFilter'
import CustomFiltersMenu from 'components/ui/custom-filters-menu-button'
import React from 'react'

const DateFilterMenu = ({
  filterModel,
  onSetDateFilter,
  isOpen,
  anchorEl,
  onOpenFilters,
  onClose,
  badgeColor,
}: {
  filterModel: GridFilterModel
  onSetFilter: (fieldName: string, selectedValues: string[]) => void
  onSetDateFilter: (fieldName: string, fromDate: string | null, toDate: string | null) => void
  isOpen: boolean
  anchorEl: HTMLElement | null
  onOpenFilters: (event: React.MouseEvent) => void
  onClose: () => void
  badgeColor?: string
}) => {
  return (
    <>
      <CustomFiltersMenu
        icon={<DateRangeIcon />}
        onOpenCustomFilters={onOpenFilters}
        count={filterModel?.items?.length ?? 0}
        badgeColor={badgeColor ?? 'text.primary'}
      />
      <CustomFiltersModal isOpen={isOpen} anchorEl={anchorEl} handleCloseCustomFilters={onClose}>
        {/* <Divider sx={{ my: 1 }} /> */}
        <CustomDateRangeFilter context="startDate" filterModel={filterModel} onSetDateFilter={onSetDateFilter} />
        <CustomDateRangeFilter context="endDate" filterModel={filterModel} onSetDateFilter={onSetDateFilter} />
      </CustomFiltersModal>
    </>
  )
}
export default DateFilterMenu
